require('./blocks/news/news');
require('./blocks/articles/articles');
require('./blocks/tags.less');
require('./blocks/soc-area.less');
require('./blocks/rating-stars/rating-stars');
require('./blocks/review.less');
require('./blocks/reviews/reviews');
require('./blocks/impromptu/impromptu-comment');

require('./blocks/product/product.less');
require('./blocks/products-slider/products-slider');

const Trackers = require('./blocks/tracker/tracker');
const PreLoader = require('./modules/preloader');

const trackers = new Trackers();

jQuery(function($) {

    $(document).on('click', '.js-subscribe-link', function() {
        let email = $(this).prev().val();
        const emailPattern = /^([a-z0-9_.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
        if (emailPattern.test(email) === false) {
            alert('Укажите правильный адрес электронной почты.');
            return false;
        }

        const loader = new PreLoader();
        loader.show();

        $.ajax({
            type: 'POST',
            url: '/ajax/action/subscribe_form/subscribe/',
            data: {
                email: email
            },
            success: function(response) {
                loader.hide();

                trackers.onSubscriptionDone();

                alert('Вы успешно подписаны!');
                location.reload();
            },
            dataType: 'json'
        });
    });
});



// WEBPACK FOOTER //
// ./article.js